<template>
  <div class="uk-grid" uk-grid>
    <div class="uk-width-1-1" v-if="packages">
      <div class="b2b-vehicle-list">
        <PackageCard :pkg="pkg" v-for="pkg in packages" :key="pkg.id" @added="onAddedToCart"></PackageCard>
      </div>
    </div>
    <div
      class="uk-width-1-1"
      v-if="meta && meta.pagination.total_pages > 1 && meta.pagination.total_pages !== meta.pagination.current_page"
    >
      <pagination :pagination="meta.pagination"></pagination>
    </div>
  </div>
</template>
<script>
import PackageService from '@/services/package.service'
import PackageCard from '@/components/vehicles/PackageCard'
import Pagination from '@/components/Pagination'
import 'izitoast/dist/css/iziToast.min.css'
import iziToast from 'izitoast/dist/js/iziToast.min.js'
export default {
  components: {
    PackageCard,
    Pagination
  },
  data() {
    return {
      packages: null,
      meta: null
    }
  },
  mounted() {
    this.getPackages()
  },
  watch: {
    '$route.query': {
      handler(query) {
        this.getPackages(1, query)
      },
      deep: true
    }
  },
  computed: {},
  methods: {
    getPackages() {
      PackageService.getList().then(response => {
        this.packages = response.data
      })
    },
    onAddedToCart() {
      iziToast.success({
        title: 'Achtung!',
        message: 'Paket wurde in den Warenkorb gelegt!',
        timeout: 5000,
        position: 'topCenter'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.v-select {
  background: #fff;
  border-radius: 4px;
}
</style>
